import {
  FIELD_OF_STUDY_LIST_REQUEST,
  FIELD_OF_STUDY_LIST_SUCCESS,
  FIELD_OF_STUDY_LIST_FAIL,
} from "../constants/fieldofStudyConstants";
import { api2 } from "../core/api";

export const getFieldOfStudy = () => async (dispatch) => {
  try {
    dispatch({
      type: FIELD_OF_STUDY_LIST_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api2.get("/interestedfieldofstudy", config);

    var dt = data.Result;

    if (typeof dt === "string") {
      dispatch({
        type: FIELD_OF_STUDY_LIST_FAIL,
        payload: dt.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: FIELD_OF_STUDY_LIST_SUCCESS,
        payload: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: FIELD_OF_STUDY_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
